import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Permissions from "./Permissions";
import { Button } from "@mui/material";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import SelectMenuItem from "../../../Component/DigitalMarketing/SelectMenuItem";
import { useGetRoleManagementsMasterQuery, useGetRoleManagementsQuery } from "../../../Service/roleManagement";
import { useGetModulesQuery, useGetPermissionsQuery } from "../../../Service/permissionManagement";
import CheckBox from "./Component/CheckBox";
export default function PermissionManager() {
  const dispatch = useDispatch<any>();
  const { data: RoleManagementsResponse,refetch } = useGetRoleManagementsMasterQuery( {
    refetchOnMountOrArgChange: true,
  });
  const { data: PermissionsResponse } = useGetPermissionsQuery()
  const { data: ModulesResponse } = useGetModulesQuery()
  const [deselect, setDeselect] = useState(false);
  const [add, setAdd] = useState(false);
  const [roles, setRoles] = useState([]);
  

  const [selectedRole, setSelectedRole] = useState(1);
  // console.log(PermissionsResponse);
  // console.log(ModulesResponse);

  
  useEffect(() => {
      if (RoleManagementsResponse) {
          setRoles(RoleManagementsResponse?.data.map(item => ({ label: item.roleName, value: item.id })))
      }
  }, [RoleManagementsResponse])
  useEffect(() => {
    const data: any = {
      first: "Permission Management",
    };
    dispatch(Change(data));
  }, [dispatch]);
  // console.log(roles, selectedRole);
  
  const handleChangeInfo = (event) => {
    if(event.target.checked){
      setAdd(true);
      setDeselect(false);

    }
    else {
      setDeselect(true);
      setAdd(false);

    }

  }
  
  useEffect(() => {
   refetch();
  }, [])
  
  return (
    <div
    className="mb-4"
      style={{
        width: "100%",
        background: "white",
        padding: 10,
        borderRadius: 6,
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
      <div style={{ display: "flex", alignItems: "end",width:"60%" }}>
        <SelectMenuItem
          styles={"select"}
          name="role"
          option={roles}
          value={selectedRole}
          label="Select Role"
          handleChange={(e) => {setSelectedRole(e.target.value); setAdd(false);}}
          placeholder="Select Role"
        />

        {/* <Button variant="contained" style={{height:"40px"}} id="btn">
                    save
                </Button> */}
      </div>
      <div>
      <CheckBox
            label="Select All"
            name="selection"
            id="selection"
            className="me-5"
            handleChange={handleChangeInfo}
            add={add}
            // checkboxstatus={handleCheckboxStatus}
          />
      </div>
      </div>

      {selectedRole && (
        <Permissions
          key={selectedRole}
          permissions={PermissionsResponse}
          modules={ModulesResponse}
          id={selectedRole}
          add={add}
          deselect={deselect}

        />
      )}
    </div>
  );
}
